import { useContext } from 'react'
import { DndContext } from '../contexts/DropAndDragContext'

export const useDnd = () => {
  const context = useContext(DndContext)

  return context
}
